import React from 'react'
import MenuItem from '@material-ui/core/MenuItem';

import { SelectInput } from '../Inputs'

const choices = [
    {
        "name": "EN OPERACIÓN",
        "value": "EN_OPERACION"
    },
    {
        "name": "EN PROYECTO",
        "value": "EN_PROYECTO"
    },
    {
        "name": "FUERA DE OPERACIÓN",
        "value": "FUERA_OPERACION"
    }
]

export const StatusSelectInput = (props) => (
    <SelectInput {...props}>
        {choices.map(choice => (
            <MenuItem key={choice.value} value={choice.value}>{choice.name}</MenuItem>
        ))}
    </SelectInput>
)
